import * as React from "react";
import {Component } from "react";

import {observer} from "mobx-react";
import _ from "lodash";
import {Button, Item, Message, Placeholder, Popup, Table} from "semantic-ui-react";
import {Auftragsverwaltung} from "../../stores/auftragsverwaltung-mobx";
import {Project} from "../../models/project";
import {PartialOrder} from "../../models/partial-order";
import {AppState} from "../../components/app/app-mobx";
import {Icon} from "../../core/components/icon/icon";
import {PartialOrderGhkForm} from "./partial-order-ghk-form";

export interface PartialOrderGhkListProps {
    appStore: AppState;
    auftragsverwaltung: Auftragsverwaltung;
    project: Project;
    title?: string;
}
interface SortAction {
    type: string;
    column: string;
}
@observer
export class PartialOrderGhkList extends Component<PartialOrderGhkListProps, any> {
    watchHandles: any[] = [];
    constructor(props: PartialOrderGhkListProps) {
        super(props);
        this.state = {
            isLoading: true,
            error: null,
            column: null,
            data: null,
            direction: null,
            riskEvidenceEvaluationCodes: null
        };
        this.sort = this.sort.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
    }

    componentDidMount(): void {
        this.loadPartialOrders();
        this.loadDomains();
    }
    componentDidUpdate(): void {}

    componentWillUnmount(): void {
        this.watchHandles.forEach((handle: any) => {
            handle.remove();
        });
        this.watchHandles.length = 0;
    }

    render(): React.ReactElement | null {
        const {appStore, auftragsverwaltung, project} = this.props;
        const { column, data, direction, isLoading, error, riskEvidenceEvaluationCodes } = this.state;

        if (isLoading) {
            return (
                <div>
                    <h3 id="react-arcgis-loading-text">Teilaufträge laden...</h3>
                    <Placeholder>
                        <Placeholder.Header>
                            <Placeholder.Line />
                        </Placeholder.Header>
                    </Placeholder>
                </div>
            );
        }

        if(error) {
            return (
                <Message negative>
                    <Message.Header>Fehler beim Laden der Teilaufträge</Message.Header>
                    {error}
                </Message>
            );
        }

        let newPartialOrderGhkButton: React.ReactElement | null = null;
        if (project.isAlterable) {
            newPartialOrderGhkButton = (
                <Popup content="Teilauftrag Gefahrenkarte hinzufügen"
                    trigger={
                        <Button className={"new-partial-order"} circular
                            onClick={(e: React.MouseEvent) => {
                                e.preventDefault();
                                const target = e.target as HTMLElement;
                                target.blur();

                                this.handleNewPartialOrder(project);
                            }}>
                            <Icon name={"navigate_plus"} />
                        </Button>
                    } />
            );
        }

        let form: React.ReactElement | null = null;
        if (auftragsverwaltung.selectedPartialOrderGhk &&
            auftragsverwaltung.isEditingPartialOrderGhk) {
            form = (
                <PartialOrderGhkForm
                    appStore={appStore}
                    auftragsverwaltung={auftragsverwaltung}
                    project={project}
                    onCancel={this.handleCancel}
                    onSave={() => this.handleSave() }
                />
            );
        }

        if (data.length === 0) {
            return (
                <>
                    {newPartialOrderGhkButton}
                    {form}
                    <Item.Group className={"geo-partial-orders"}>
                        <Item><Item.Content><p>keine Teilaufträge Gefahrenhinweiskarte</p></Item.Content></Item>
                    </Item.Group>
                </>
            );
        }
        return (
            <>
                {newPartialOrderGhkButton}
                {form}
                <Item.Group className={"geo-partial-orders"}>
                    <Item>
                        <Item.Content>
                            <Table basic="very" fixed singleLine sortable={(data.length > 1)} compact className={"process-sources"}>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell width={12} sorted={column === "riskEvidenceEvaluationId" ? direction : null}
                                            onClick={() => this.sort({ type: "CHANGE_SORT", column: "riskEvidenceEvaluationId" })}>
                                            Gefahrenhinweisprozess
                                        </Table.HeaderCell>
                                        {project.isAlterable &&
                                            <Table.HeaderCell width={4}></Table.HeaderCell>
                                        }
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body>
                                    {data.map((partialOrder: PartialOrder) => (
                                        <Table.Row key={partialOrder.objectId} >
                                            <Table.Cell className={"riskEvidenceEvaluationId"}>
                                                {riskEvidenceEvaluationCodes.get(partialOrder.riskEvidenceEvaluationId)}
                                            </Table.Cell>
                                            {project.isAlterable &&
                                                <Table.Cell>
                                                    <>
                                                        <Popup content="Teilauftrag Gefahrenkarte ändern"
                                                            trigger={
                                                                <Button className={"edit-partial-order"} circular
                                                                    onClick={(e: React.MouseEvent) => {
                                                                        e.preventDefault();
                                                                        const target = e.target as HTMLElement;
                                                                        target.blur();

                                                                        this.handleEdit(partialOrder);
                                                                    }}>
                                                                    <Icon name={"pencil"} />
                                                                </Button>
                                                            } />
                                                        <Popup content="Teilauftrag Gefahrenkarte löschen"
                                                            trigger={
                                                                <Button className={"edit-partial-order"} circular
                                                                    onClick={(e: React.MouseEvent) => {
                                                                        e.preventDefault();
                                                                        const target = e.target as HTMLElement;
                                                                        target.blur();

                                                                        this.handleDelete(partialOrder);
                                                                    }}>
                                                                    <Icon name={"garbage_can"} />
                                                                </Button>
                                                            } />
                                                    </>
                                                </Table.Cell>
                                            }
                                        </Table.Row>
                                    ))}
                                </Table.Body>
                            </Table>
                        </Item.Content>
                    </Item>
                </Item.Group>
            </>
        );
    }

    private handleNewPartialOrder(project: Project): void {
        const {auftragsverwaltung, appStore} = this.props;

        if (!project.id) {
            return;
        }

        const user = appStore.esriCredential?.userId || "";
        auftragsverwaltung.PartialOrderGhkStore.newItem(project.id, "partial-order-ghk", user).then(() => {
            // do not show map when editing
            auftragsverwaltung.setShowMap(false);
            auftragsverwaltung.setEditing(true, "partial-order-ghk");
        });
    }

    private handleCancel(): void {
        const {auftragsverwaltung} = this.props;
        auftragsverwaltung.setEditing(false);
    }

    private handleSave(): void {
        this.loadPartialOrders();
    }

    private handleDelete(partialOrder: PartialOrder): void {
        this.setState({
            isLoading: true
        });

        if (confirm("Teilprojekt wirklich löschen?")) {
            const {appStore, auftragsverwaltung, project} = this.props;

            const user = appStore.esriCredential?.userId || "";
            auftragsverwaltung.PartialOrderGhkStore.delete(project, partialOrder, user).then(() => {
                this.setState((state) => {
                    const data = state.data.filter((po) => po !== partialOrder);
                    return {
                        data,
                        isLoading: false
                    };
                });
            });
        }
    }

    private handleEdit(partialOrder: PartialOrder): void {
        const {auftragsverwaltung} = this.props;

        // do not show map when editing
        auftragsverwaltung.setShowMap(false);
        auftragsverwaltung.PartialOrderGhkStore.setSelectedItem(partialOrder);
        auftragsverwaltung.setEditing(true, "partial-order-ghk");
    }

    private loadPartialOrders(): void {
        const {project, auftragsverwaltung} = this.props;

        if (!project || !project.id) {
            return;
        }

        auftragsverwaltung.PartialOrderGhkStore.loadItems(project.id).then((partialOrders: PartialOrder[]) => {
            const data = _.orderBy(partialOrders, ["name"], ["asc"]);
            this.setState({
                data,
                column: "name",
                direction: "ascending",
                isLoading: false
            });
        }).catch((error) => {
            this.setState({
                error
            });
        });
    }

    /**
     * Load domains
     *
     * @private
     */
    private loadDomains(): void {
        const {auftragsverwaltung} = this.props;

        auftragsverwaltung.getShortDomainCodes(
            "partial-order-ghk",
            "riskEvidenceEvaluationId").then((riskEvidenceEvaluationCodes) => {
            this.setState({
                riskEvidenceEvaluationCodes
            });
        });
    }

    private sort(action: SortAction): void {
        switch (action.type) {
        case "CHANGE_SORT":
            if (this.state.column === action.column) {
                this.setState((state: any) =>({
                    data: state.data.reverse(),
                    direction: state.direction === "ascending" ? "descending" : "ascending"
                }));
            } else {
                // TODO: sortieren nach Domäne nicht nach code
                this.setState((state: any) =>({
                    column: action.column,
                    data: _.sortBy(state.data, [action.column], ["asc"]),
                    direction: "ascending",
                }));
            }
            return;
        default:
            throw new Error();
        }
    }
}
